export class DelayedRequestQueue {
  constructor() {
    this.queue = []
    this.delay = 50
    this.processing = false
  }

  setup(delay = 50) {
    this.delay = delay
  }

  schedule(task) {
    return new Promise((resolve, reject) => {
      this.queue.push({ task, resolve, reject })
      if (!this.processing) this.processQueue()
    })
  }

  async processQueue() {
    if (this.processing) return
    this.processing = true

    while (this.queue.length > 0) {
      const { task, resolve, reject } = this.queue.shift()
      try {
        // Déclenche la tâche mais ne pas await pour ne pas bloquer la suivante
        const resultPromise = task()
        resolve(resultPromise)
      } catch (err) {
        reject(err)
      }

      // Attente fixe avant de déclencher la suivante
      await new Promise(r => setTimeout(r, this.delay))
    }

    this.processing = false
  }
}
